export const fromSnakeToCamel = (snake: string): string => {
  return snake.toLowerCase().replace(/_./g, str => str.charAt(1).toUpperCase())
}
export const fromCamelToSnake = (camel: string): string => {
  return camel.replace(/([A-Z])/g, str => '_' + str.charAt(0).toLowerCase())
}
